import request from "superagent";
import APP_ENV from "../Environment";

export const fetchSocialProviderInfo = (key) => {
    return new Promise((resolve, reject) => {
        request
            .get(`${APP_ENV.BFF}/social-provider/tokens?key=${key}`)
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .end((err, res) => {
                if (err) {
                    reject(err);
                    return;
                }
                resolve({cognito_user_attributes: res.body.information});
            });
    });

};